import styled from 'styled-components';

export default styled.div`
  padding: 24px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
`;
